
export enum UserStatus {
  Pending = 'Pending',
  Active = 'Active',
  Blocked = 'Blocked',
}
